import { DigitalSignCommonData } from "@/mixins/crk/interface";
import { IStoreRootState } from "@/store/interface";
import { ActionTree } from "vuex";
import { $createPaymentRequirementsOutgoing, $recallOutgoingPaymentRequirements } from "../../api/outgoing/payment-requirements-outgoing";
import { PaymentRequirementsOutgoingAction } from "./constants";
import { PaymentRequirementsOutgoingState } from "./interface";

export default <ActionTree<PaymentRequirementsOutgoingState, IStoreRootState>> {

	async [PaymentRequirementsOutgoingAction.recallPayment](
		{},
		payload: DigitalSignCommonData
	): Promise<boolean> {
		return $recallOutgoingPaymentRequirements(payload);
	},

	async [PaymentRequirementsOutgoingAction.create](
		{},
		payload: DigitalSignCommonData
	): Promise<boolean> {
		return $createPaymentRequirementsOutgoing(payload);
	},

}